import styled from "styled-components";

const LabelRemember = styled.label({
  display: "flex",
  alignItems: "center",
  gap: 8,
});

export { LabelRemember }